import { Component, Injector, Input } from '@angular/core';
import { HiveMessageService } from '../services/hivemessage.service';

/**
 * Mobile Phone HiveMessage Component
 * Displays a WhatsApp icon button next to phone fields for mobile view
 * Used for registering phone fields in SuiteCRM's field registry
 */
@Component({
  selector: 'lib-mobile-phone-hivemessage',
  templateUrl: './mobile-phone-hivemessage.component.html',
  styleUrls: ['./mobile-phone-hivemessage.component.scss']
})
export class MobilePhoneHiveMessageComponent {
  showHiveMessage: boolean = false;
  
  @Input() field: any;
  @Input() record: any;
  
  protected injector: Injector;

  constructor(
    injector: Injector,
    protected hivemessageService: HiveMessageService
  ) {
    this.injector = injector;
    // Field and record will be set by SuiteCRM's field component system
  }

  /**
   * Open the HiveMessage modal
   */
  openHiveMessage(): void {
    if (!this.field?.value) {
      console.warn('Phone number is required');
      return;
    }
    this.showHiveMessage = true;
  }

  /**
   * Close the HiveMessage modal
   */
  closeHiveMessage(): void {
    this.showHiveMessage = false;
  }

  /**
   * Get the module type from the record
   * @returns Module type (e.g., 'Contacts', 'Leads', 'Accounts')
   */
  getModuleType(): string {
    return this.record?.module || '';
  }

  /**
   * Get the module record ID
   * @returns Record ID
   */
  getModuleId(): string {
    return this.record?.id || '';
  }

  /**
   * Remove formatting from phone number (spaces, dashes, etc.)
   * @param phone - Formatted phone number
   * @returns Unformatted phone number
   */
  getUnFormatted(phone: string): string {
    if (!phone) {
      return '';
    }
    // Remove all spaces, parentheses, dashes, and other formatting
    return phone.replace(/[\s()\-]/g, '');
  }
}

